import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";

export const Page404 = () => {
  return (
    <Stack
      direction={"column"}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          minHeight: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 2,
            margin: 2,
            textAlign: "center",
            color: "text.secondary",
            backgroundColor: "#fff",
            borderRadius: "24px",
            width: "400px",
            height: "300px",
            borderStyle: "dashed",
            borderWidth: "5px",
            borderColor: "#FFB82B",
          }}
        >
          <Stack
            spacing={2}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box>
              <WarningAmberOutlined
                sx={{ fontSize: 100, color: "#FFB82B", opacity: 0.8 }}
              />
            </Box>

            <Box>
              <Typography variant="h4" component="h1" gutterBottom>
                404 - Page Not Found
              </Typography>
            </Box>
            <Box>
              <Typography variant="body1">
                Sorry, the page you are looking for does not exist.
              </Typography>
            </Box>
            <Box>
              <Typography variant="body1">Please check the URL.</Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Stack>
  );
};
